import AirDash from '../../assets/muvtech/Muvdata/WallCharger/AirDash.png';
import AirExplorer from '../../assets/muvtech/Muvdata/WallCharger/AirExplorer.png';
import AirLight from '../../assets/muvtech/Muvdata/WallCharger/AirLight.png';
import AirdashPro from '../../assets/muvtech/Muvdata/WallCharger/AirdashPro.png';
import Airdashmini from '../../assets/muvtech/Muvdata/WallCharger/Airdashmini.png';
import AirlightPro from '../../assets/muvtech/Muvdata/WallCharger/AirlightPro.png';

const wallchargerData = [
  {
    id: 1,
    type: 'wallcharger',
    title: 'Air Light',
    compatibleModels: 'All Electronic Devices',
    price: 1499,
    specs: ['20W', 'Single/Dual USB-C Ports'],
    image: [AirLight],
  },
  {
    id: 2,
    type: 'wallcharger',
    title: 'Air Light Pro',
    compatibleModels: 'All Electronic Devices',
    price: 1499,
    specs: ['25W', 'Dual Charging'],
    image: [AirlightPro],
  },
  {
    id: 3,
    type: 'wallcharger',
    title: 'Air Dash',
    compatibleModels: 'All Electronic Devices',
    price: 2499,
    specs: ['33W', 'GaN Tech'],
    image: [AirDash],
  },
  {
    id: 4,
    type: 'wallcharger',
    title: 'Air Dash Mini',
    compatibleModels: 'All Electronic Devices',
    price: 2999,
    specs: ['35W', 'Dual USB-C'],
    image: [Airdashmini],
  },
  {
    id: 5,
    type: 'wallcharger',
    title: 'Air Dash Pro',
    compatibleModels: 'All Electronic Devices',
    price: 2999,
    specs: ['40W', 'GaN', '2 USB-C'],
    image: [AirdashPro],
  },
  {
    id: 6,
    type: 'wallcharger',
    title: 'Air Explorer',
    compatibleModels: 'All Electronic Devices',
    price: 5999,
    specs: ['67W', '3 Port', 'PD & QC'],
    image: [AirExplorer],
  },
];

export default wallchargerData;
